import type { GamePageResponse, GPGameTeamResponse } from "../types";

export type TeamTaggedSide = "home" | "away";

export function isOneTeamTagged(teamTagged: string | null | undefined): teamTagged is TeamTaggedSide {
	return teamTagged === "home" || teamTagged === "away";
}

export function getTaggedTeamSide(teamTagged: string | null | undefined): TeamTaggedSide | null {
	if (isOneTeamTagged(teamTagged)) {
		return teamTagged;
	}

	return null;
}

export function getTaggedGameTeam(gameData: GamePageResponse): GPGameTeamResponse | null {
	const taggedSide = getTaggedTeamSide(gameData.game?.teamTagged);

	if (taggedSide === "home") {
		return gameData.homeGameTeam;
	}

	if (taggedSide === "away") {
		return gameData.awayGameTeam;
	}

	return null;
}
